
export const hammerBasicColors = [
  '#9FFEFE',
  '#FFB871',
  '#9F9FFE',
  '#EE6AB2',
  '#6DF6B2',
  '#CBCBFE',
  '#FE9F9F',
  '#66CDD0',
  '#FECBCB',
  '#6666CC',
  '#E5FEE5',
  '#FE7F7F',
  '#98ACFE',
  '#54DF8E',
  '#FEFECB',
  '#B55BE4',
  '#FE6666',
  '#539B53',
  '#58B586',
  '#C8D6E9',
  '#FEBFD8',
  '#9FC8FE',
  '#A1FE98',
  '#98FEBA',
  '#7FFE94',
  '#CB6666',
  '#43B743',
  '#66CB98',
  '#CB9833',
  '#BE7EFF',
  '#CBFEB2',
  '#B2FEB2',
  '#CB98E5',
  '#9FE5E5',
  '#CBE5FE',
  '#CB98E5',
  '#FEE5FE',
  '#FE9833',
  '#FE9FB2',
  '#3BB7B7',
  '#CB66CB',
  '#FEFE98',
  '#FEF1F1',
  '#FE8D71',
  '#FE9FCB',
  '#66CB66',
  '#FED8EB',
  '#D7B26A',
  '#B2B2FE',
  '#FE9FE5',
];
